import React from "react";

import Typewriter from "typewriter-effect";

export const Type = () => {
  return (
    <>
      <Typewriter
        options={{
          strings: ["Enthusiastic Dev 💻", "Full Stack Mern Web Developer 🖥", "React/Redux Developer","Motivational Speaker"],
          autoStart: true,
          loop: true,
          deleteSpeed: 70
        }}
      />
    </>
  );
};
